import type { AssetRef } from '#src/types/chat.ts';
import { BaseApiService } from './base-api.service';

/** The per-message attachment limits, defined by the backend only. */
export interface AttachmentLimits {
	maxFilesPerMessage: number;
	maxTokensPerMessage: number;
}

export type UploadedAsset = AssetRef & {
	tokenCount?: number;
	limits?: AttachmentLimits;
};

/**
 * Chat attachments for standard conversations. Uploading only stores the file
 * and hands back a reference — attaching it to a message is the caller's next
 * step, the same way an agent-generated asset ends up on the message that
 * produced it. An antonio visitor's photo goes to the conversation instead
 * (AntonioChatApiService.uploadUserImage).
 */
export class AssetApiService extends BaseApiService {
	/** The upload names only its instance: it starts unbound and joins its
	 *  conversation when the message carrying it is sent (see
	 *  backend/routes/asset_upload.go). */
	upload(file: File, instanceId: string): Promise<UploadedAsset> {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('instance', instanceId);
		return this.apiFetch<UploadedAsset>('POST', '/api/assets', formData);
	}

	/** Removes a chat attachment that hasn't been sent yet. */
	delete(assetId: string): Promise<void> {
		return this.apiFetch('DELETE', `/api/assets/${assetId}`);
	}
}

export const assetApiService = new AssetApiService();
